import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { getOverallGrade } from '~/statistics-v2/utils/statistics.utils'
import { AppLanguage } from '~/types/locale'

export default function MindTipsCard({
  percentage,
  setIsMindTipsCardVisible,
}: {
  percentage: number
  setIsMindTipsCardVisible: (visible: boolean) => void
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  const router = useRouter()
  const currentGrade = getOverallGrade(percentage, router.locale as AppLanguage)

  useEffect(() => {
    setIsMindTipsCardVisible(currentGrade !== '-')
  }, [currentGrade, setIsMindTipsCardVisible])

  return (
    <div className="flex bg-purple-darker min-h-26 rounded overflow-hidden">
      <div className="bg-purple min-w-1 min-h-full" />
      <div className="flex flex-col justify-start items-start p-3 gap-2">
        <div className="flex gap-1">
          <ResponsiveImage
            alt="Mind Icon"
            fit="contain"
            height={24}
            imageClassName="object-contain w-6 h-6 -rotate-30"
            srcKey="landing/mind-ai-v2.png"
            width={24}
          />
          <p className="text-sm leading-6 text-pretty">{t('mindTips.title')}</p>
        </div>
        <div className="flex text-xs leading-6 tracking-tighter w-full">
          <p className="text-sm ">{t(`mindTips.grade${currentGrade}`, { score: Math.round(percentage) })}</p>
        </div>
      </div>
    </div>
  )
}
